import clsx from 'clsx';
import {SanityNavigationPrimary} from '../../../types';
import NavigationLink from './NavigationLink';

type Props = {
  primaryNavigation?: SanityNavigationPrimary;
  className?: string;
};

export default function NavigationTop({primaryNavigation, className}: Props) {
  return (
    <nav className={clsx('hidden gap-6 text-sm md:flex', className)}>
      {primaryNavigation?.links &&
        primaryNavigation?.links.map((link) => (
          <NavigationLink key={link._key} link={link} />
        ))}
    </nav>
  );
}
